import type { IScope } from "angular";
import { finalize } from "rxjs/operators";

import type { IEquipmentType, IResponseWithLoading } from "App/Modules/Models";
import type { IEquipmentTypeRepository } from "App/Modules/Repositories";
import type { IPageService } from "App/Modules/Services";
import { addLoading } from "App/Modules/Services";
import { extendWithLoadingAndFail } from "App/Modules/Services/ObservableExtensions";

export default class EquipmentTypeComponentController {
    public static $inject: string[] = ["$scope", "mmEquipmentTypeRepository", "irPageService"];

    public equipmentTypeId: string;

    public equipmentType: IResponseWithLoading<IEquipmentType>;

    constructor(
        private readonly $scope: IScope,
        private readonly equipmentTypeRepository: IEquipmentTypeRepository,
        private readonly pageService: IPageService,
    ) {}

    public $onInit() {
        extendWithLoadingAndFail(this.equipmentTypeRepository.getEquipmentType(this.equipmentTypeId))
            .pipe(
                addLoading(this.pageService),
                finalize(() => this.$scope.$applyAsync()),
            )
            .subscribe(
                (response: IResponseWithLoading<IEquipmentType>) => {
                    this.equipmentType = response;
                },
                (error) => {
                    this.equipmentType = error;
                },
            );
    }
}
